/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const getWishlistButtonCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  const {styleParams} = customCssVarsFnParams;

  const getWishlistButtonSizeWithAddToCartValue = () => {
    const addToCartButtonBorderWidth = styleParams.strings?.productPage_actionButtonborderSize?.value;
    return `calc(16px + (2 * ${addToCartButtonBorderWidth}) + 1.5em)`;
  };

  const getWishlistButtonSizeWithDirectPurchaseButtonValue = () => {
    const directPurchaseButtonBorderWidth = styleParams.strings?.productPage_buyNowButtonBorderSize?.value;
    return `calc(16px + (2 * ${directPurchaseButtonBorderWidth}) + 1.5em)`;
  };

  const getWishlistButtonSizeWithoutSubscribeButtonValue = () => {
    if (styleParams.booleans.productPage_productAction) {
      return getWishlistButtonSizeWithAddToCartValue();
    } else if (styleParams.booleans.productPage_buyNowButtonEnabled) {
      return getWishlistButtonSizeWithDirectPurchaseButtonValue();
    }
    return '28px';
  };

  return {
    wishlistButtonContainerFlexGrow:
      !styleParams.booleans.productPage_productAction && !styleParams.booleans.productPage_buyNowButtonEnabled
        ? '1'
        : 'revert',
    wishlistButtonSizeWithSubscribeButton: getWishlistButtonSizeWithDirectPurchaseButtonValue(),
    wishlistButtonSizeWithoutSubscribeButton: getWishlistButtonSizeWithoutSubscribeButtonValue(),
  };
};

export const getWishlistButtonShouldRenderVars = ({booleans}: ShouldRenderVarsFnParams) => {
  const isAddToCartButtonEnabled = booleans.productPage_productAction;
  const isBuyNowButtonEnabled = booleans.productPage_buyNowButtonEnabled;

  return {
    shouldRenderWishlistIconButton: isAddToCartButtonEnabled || isBuyNowButtonEnabled,
    shouldRenderWishlistFullWidthButton: !isAddToCartButtonEnabled && !isBuyNowButtonEnabled,
  };
};
